export const ZINDEX_NAV = 50;

export const ZINDEX_MODAL = 999;

export const ZINDEX_MODAL_BACKGROUND = 300;
